<template>
  <div class="main" :style="{ height: scrollHeight }">
    <van-swipe
      class="my-swipe box"
      indicator-color="#000"
      :loop="false"
      :show-indicators="false"
      vertical
    >
      <van-swipe-item>
        <div
          :style="{
            'background-image':
              'url(' + $commonUrl.cos() + '/image/recruiting/page1bj.png)',
          }"
          class="commute-list-bigpic box page1"
        >
          <img
            :src="this.$commonUrl.cos() + '/image/recruiting/logo.png'"
            alt=""
            class="logo"
          />
          <img
            :src="this.$commonUrl.cos() + '/image/recruiting/pagemian.png'"
            alt=""
            class="pagemain"
          />
          <img
            :src="this.$commonUrl.cos() + '/image/recruiting/icon.png'"
            alt=""
            class="icon"
          />
        </div>
      </van-swipe-item>
      <van-swipe-item>
        <div
          :style="{
            'background-image':
              'url(' + $commonUrl.cos() + '/image/recruiting/page1bj.png)',
          }"
          class="commute-list-bigpic box page2"
        >
          <img
            :src="this.$commonUrl.cos() + '/image/recruiting/page2main.png'"
            alt=""
            class="page2main"
          />
          <img
            :src="this.$commonUrl.cos() + '/image/recruiting/page2tittle.png'"
            alt=""
            class="page2tittle"
          />
          <img
            :src="this.$commonUrl.cos() + '/image/recruiting/renpage2.png'"
            alt=""
            class="renpage2"
          />
          <img
            :src="this.$commonUrl.cos() + '/image/recruiting/icon.png'"
            alt=""
            class="icon"
          />
        </div>
      </van-swipe-item>
      <van-swipe-item>
        <div
          :style="{
            'background-image':
              'url(' + $commonUrl.cos() + '/image/recruiting/page1bj.png)',
          }"
          class="commute-list-bigpic box page3"
        >
          <img
            :src="this.$commonUrl.cos() + '/image/recruiting/pagemain3.png'"
            alt=""
            class="pagemain3"
          />
          <img
            :src="this.$commonUrl.cos() + '/image/recruiting/renpage2.png'"
            alt=""
            class="renpage2"
          />
          <img
            :src="this.$commonUrl.cos() + '/image/recruiting/icon.png'"
            alt=""
            class="icon"
          />
        </div>
      </van-swipe-item>
      <van-swipe-item>
        <div
          :style="{
            'background-image':
              'url(' + $commonUrl.cos() + '/image/recruiting/page1bj.png)',
          }"
          class="commute-list-bigpic box page4"
        >
          <img
            :src="this.$commonUrl.cos() + '/image/recruiting/page4main.png'"
            alt=""
            class="pagemain4"
          />
          <img
            :src="this.$commonUrl.cos() + '/image/recruiting/renpage2.png'"
            alt=""
            class="renpage2"
          />
          <img
            :src="this.$commonUrl.cos() + '/image/recruiting/icon.png'"
            alt=""
            class="icon"
          />
        </div>
      </van-swipe-item>
      <van-swipe-item>
        <div
          :style="{
            'background-image':
              'url(' + $commonUrl.cos() + '/image/recruiting/page1bj.png)',
          }"
          class="commute-list-bigpic box page4"
        >
          <img
            :src="this.$commonUrl.cos() + '/image/recruiting/page5main.png'"
            alt=""
            class="pagemain4"
          />
          <img
            :src="this.$commonUrl.cos() + '/image/recruiting/renpage2.png'"
            alt=""
            class="renpage2"
          />
          <img
            :src="this.$commonUrl.cos() + '/image/recruiting/icon.png'"
            alt=""
            class="icon"
          />
        </div>
      </van-swipe-item>

      <van-swipe-item>
        <div
          :style="{
            'background-image':
              'url(' + $commonUrl.cos() + '/image/recruiting/page1bj.png)',
          }"
          class="commute-list-bigpic page6"
        >
          <!-- <img
            class="page6bj"
            :src="this.$commonUrl.cos() + '/image/recruiting/page6bj.png'"
            alt=""
          /> -->
          <div
            class="page6bj"
            :style="{
              'background-image':
                'url(' + $commonUrl.cos() + '/image/recruiting/page6bj.png)',
            }"
          >
            <div class="boxSubmit">
              <div class="boxInput sex">
                <label for="gender">性别<span>*</span></label>
                <div class="itemBox">
                  <div class="item">
                    <img :src="nan" alt="" @click="check(1)"/>
                    <span>男</span>
                  </div>
                  <div class="item">
                    <img :src="nv" alt="" @click="check(2)"/>
                    <span>女</span>
                  </div>
                </div>
              </div>
              <div class="boxInput">
                <label for="phoneNumber">手机号<span>*</span></label>
                <input type="text" v-model="formDate.phoneNumber"/>
              </div>
              <div class="boxInput">
                <label for="jobName">职业</label>
                <input type="text" v-model="formDate.jobName"/>
              </div>
              <div class="boxInput">
                <label for="cityName">城市<span>*</span></label>
                <!-- <input type="text" v-model="formDate.cityName" /> -->
                <div @click="showPicker = true" class="city">
                  {{ formDate.cityName }}
                  <img src="../../../assets/img/rightU.png" alt=""/>
                </div>
                <van-popup v-model="showPicker" round position="bottom">
                  <van-picker
                    show-toolbar
                    ref="picker"
                    :columns="columns"
                    @cancel="showPicker = false"
                    @confirm="onConfirm"
                    value-key="name"
                  />
                </van-popup>
              </div>
            </div>
            <img
              :src="this.$commonUrl.cos() + '/image/recruiting/submint.png'"
              alt=""
              class="submint"
              @click="verify"
            />
            <img
              :src="this.$commonUrl.cos() + '/image/recruiting/down.png'"
              alt=""
              class="down"
              @click="linkGo"
            />
          </div>
          <img
            :src="this.$commonUrl.cos() + '/image/recruiting/renpage2.png'"
            alt=""
            class="renpage2"
          />

          <img
            :src="this.$commonUrl.cos() + '/image/recruiting/sharebtn.png'"
            alt=""
            class="sharebtn"
            @click="popShare"
          />
        </div>
      </van-swipe-item>
    </van-swipe>
    <van-overlay :show="show" @click="show = false">
      <div class="wrapper" @click.stop>
        <div class="block">
          <img
            :src="this.$commonUrl.cos() + '/image/recruiting/erweima.png'"
            alt=""
          />
        </div>
      </div>
    </van-overlay>
    <share-list mark="分享" :showShare="showShare" @pushShare="getShare"
                :params="paramsData && paramsData.params"
                :shareAppObj="shareAppObj"
                :shareH5Obj="shareH5Obj" ref="child"></share-list>
    <!--    <share-list-all-->
    <!--      :params="paramsData && paramsData.params"-->
    <!--      :sharePlatformList="sharePlatformList"-->
    <!--      ref="child"-->
    <!--    ></share-list-all>-->
  </div>
</template>

<script>
  import util from '@/utils/util';
  import mobileType from '@/utils/mobileType';
  import JumpApp from '../../../components/common/jumpApp';
  import ShareListAll from '../../../components/share/shareListAll';
  import { saveShareParam } from '@/apis/activity/common';

  import {
    savePubliclyRecord,
    getProvinceCity,
  } from '@/apis/activity/ticketUniversal';
  import wx from 'weixin-js-sdk';
  import ShareList from '../../../components/common/shareList';

  let heightbody = document.body.offsetHeight;
  export default {
    components: {
      ShareList,
      ShareListAll,
      JumpApp,
    },
    data() {
      return {
        paramsData: {},
        nan: this.$commonUrl.cos() + '/image/recruiting/nancheck.png',
        nv: this.$commonUrl.cos() + '/image/recruiting/nvnocheck.png',
        jumpUrl: '',
        show: false, //下载app的二维码弹窗
        showShare: false,
        inputs: true,
        shareAppObj: {
          shareFriend: [{
            title: '代驾司机招募中',
            url: window.location.origin + '/home/recruiting?platform=4', //分享链接-window.location.href
            imgUrl: this.$commonUrl.cos() + '/image/recruiting/bigshare.png', //platformTag=5时，优先取imgBase64可选择传imgUrl或imgBase64,其他的值都可以不传哈
            // imgBase64: this.$commonUrl.cos() + '/image/logo.png',//platformTag=5时，优先取imgBase64可选择传imgUrl或imgBase64,其他的值都可以不传哈
            description: '收入由你，赚钱更自由！快来解锁新“钱”途',
            userName: 'gh_abcc55f26797', //小程序原始id
            path: 'active/pages/commonWeb/commonWeb', //小程序路径
            miniprogramType:
              window.location.origin == 'https://designated.wsecar.com' ? 0 : 2, //小程序 —— 0=正式版，1=测试版，2=体验版
            platformTag: 3, // 1 = QQ好友，2= QQ空间,3= 微信好友，4= 微信朋友圈，5= 保存图片，6=新浪微博(预留，暂不实现)，7=启动小程序
            shareType: 2, //分享类型（1=分享H5，2=小程序，3=分享图片）
          }],
          shareWechat: [{
            title: '代驾司机招募中',
            url: window.location.origin + '/home/recruiting?platform=4', //分享链接-window.location.href
            imgUrl: this.$commonUrl.cos() + '/image/recruiting/bigshare.png', //platformTag=5时，优先取imgBase64可选择传imgUrl或imgBase64,其他的值都可以不传哈
            imgBase64: this.$commonUrl.cos() + '/image/recruiting/bigshare.png', //platformTag=5时，优先取imgBase64可选择传imgUrl或imgBase64,其他的值都可以不传哈
            description: '收入由你，赚钱更自由！快来解锁新“钱”途',
            userName: 'gh_abcc55f26797', //小程序原始id
            path: 'active/pages/commonWeb/commonWeb', //小程序路径
            miniprogramType:
              window.location.origin == 'https://designated.wsecar.com' ? 0 : 2, //小程序 —— 0=正式版，1=测试版，2=体验版
            platformTag: 4, // 1 = QQ好友，2= QQ空间,3= 微信好友，4= 微信朋友圈，5= 保存图片，6=新浪微博(预留，暂不实现)，7=启动小程序
            shareType: 1, //分享类型（1=分享H5，2=小程序，3=分享图片）
          }]
        },
        shareH5Obj: {
          sharePlatformH5List: [
            {
              tips: '微信', //逻辑标识
              name: '微信', //1.微信,2.微博,3.QQ,4.复制链接，5.分享海报,6.二维码,7.小程序码,8.朋友圈,
              icon: 'wechat',//1.wechat,2.weibo,3.qq,4.link，5.poster,6.qrcode,7.weapp-qrcode,8.this.$commonUrl.cos() + '/image/wechatMoment.png',---也可自定义icon图标
            },
            {
              tips: '朋友圈',
              name: '朋友圈',
              icon: this.$commonUrl.cos() + '/image/wechatMoment.png'
            }
          ],
        },
        // sharePlatformList: [
        //   {
        //     title: "代驾司机招募中",
        //     url: window.location.origin + "/home/recruiting?platform=4", //分享链接-window.location.href
        //     imgUrl: this.$commonUrl.cos() + "/image/recruiting/bigshare.png", //platformTag=5时，优先取imgBase64可选择传imgUrl或imgBase64,其他的值都可以不传哈
        //     // imgBase64: this.$commonUrl.cos() + '/image/logo.png',//platformTag=5时，优先取imgBase64可选择传imgUrl或imgBase64,其他的值都可以不传哈
        //     description: "收入由你，赚钱更自由！快来解锁新“钱”途",
        //     userName: "gh_abcc55f26797", //小程序原始id
        //     path: "active/pages/commonWeb/commonWeb", //小程序路径
        //     miniprogramType:
        //       window.location.origin == "https://designated.wsecar.com" ? 0 : 2, //小程序 —— 0=正式版，1=测试版，2=体验版
        //     platformTag: 3, // 1 = QQ好友，2= QQ空间,3= 微信好友，4= 微信朋友圈，5= 保存图片，6=新浪微博(预留，暂不实现)，7=启动小程序
        //     shareType: 2, //分享类型（1=分享H5，2=小程序，3=分享图片）
        //   },
        //   {
        //     title: "代驾司机招募中",
        //     url: window.location.origin + "/home/recruiting?platform=4", //分享链接-window.location.href
        //     imgUrl: this.$commonUrl.cos() + "/image/recruiting/bigshare.png", //platformTag=5时，优先取imgBase64可选择传imgUrl或imgBase64,其他的值都可以不传哈
        //     imgBase64: this.$commonUrl.cos() + "/image/recruiting/bigshare.png", //platformTag=5时，优先取imgBase64可选择传imgUrl或imgBase64,其他的值都可以不传哈
        //     description: "收入由你，赚钱更自由！快来解锁新“钱”途",
        //     userName: "gh_abcc55f26797", //小程序原始id
        //     path: "active/pages/commonWeb/commonWeb", //小程序路径
        //     miniprogramType:
        //       window.location.origin == "https://designated.wsecar.com" ? 0 : 2, //小程序 —— 0=正式版，1=测试版，2=体验版
        //     platformTag: 4, // 1 = QQ好友，2= QQ空间,3= 微信好友，4= 微信朋友圈，5= 保存图片，6=新浪微博(预留，暂不实现)，7=启动小程序
        //     shareType: 1, //分享类型（1=分享H5，2=小程序，3=分享图片）
        //   },
        // ],
        activityId: this.$route.query.activityId,
        formDate: {
          gender: 1,
          phoneNumber: null,
          cityName: '',
          jobName: '',
        },
        shareTitle: '代驾司机招募中',
        shareImg: this.$commonUrl.cos() + '/image/recruiting/bigshare.png',
        showPicker: false,
        columns: [],
        scrollHeight: null,
      };
    },

    created() {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0,
      });
      //Vue的方法给原生调用，则需要把方法挂在Window下面
      window.getDataFromNative = this.getDataFromNative;
    },
    mounted() {
      this.paramsData = this.$apiFun.getPlatFromParams(this.$route.query);
      if (this.paramsData) {
        this.getDataFromNative();
      } else {
        this.$apiFun.getUserInfoFromApp();
      }
    },
    methods: {
      // APP交互后获取params IosAndroid必须用这个方法名定义的哦，和挂载的要一样才行~所以所小程序的也噌用它的方法名为保统一
      getDataFromNative(params) {
        if (params) {
          this.paramsData = this.$apiFun.getParamsIosAndroid(
            params,
            this.$route.query
          );
        }
        //获取活动信息
        this.getActivityInfoFun();
      },
      getActivityInfoFun() {
        let params = { ...this.paramsData.params };
        params = util.filterParams(params);
        console.log(params);
        this.$toast.clear();
        this.getSceneId();
        this.provinceCity();
        this.$apiFun.getJsSdkSignatureFun(
          this.paramsData.params,
          // this.sharePlatformList[0]
          this.shareAppObj.shareFriend[0]
        );
      },
      check(item) {
        this.formDate.gender = item;
        if (item == 1) {
          this.nan = this.$commonUrl.cos() + '/image/recruiting/nancheck.png';
          this.nv = this.$commonUrl.cos() + '/image/recruiting/nvnocheck.png';
        } else {
          this.nan = this.$commonUrl.cos() + '/image/recruiting/nannocheck.png';
          this.nv = this.$commonUrl.cos() + '/image/recruiting/nvcheck.png';
        }
      },
      //校验
      verify() {
        if (!this.formDate.gender) {
          this.$toast('请选择性别');
          return false;
        }
        const reg = /^1[3456789]\d{9}$/;
        if (this.formDate.phoneNumber) {
          if (!reg.test(this.formDate.phoneNumber)) {
            return this.$toast('请输入正确手机号');
          }
        } else {
          return this.$toast('请输入手机号');
        }
        if (this.formDate.jobName.length > 15) {
          this.$toast('职业不得超过15字');
          return false;
        }
        if (!this.formDate.cityName) {
          this.$toast('请选择城市');
          return false;
        }
        this.submit();
      },
      //城市
      async provinceCity() {
        let params = { ...this.paramsData.params };
        params.data = {
          activityId: this.activityId,
        };
        params.data = JSON.stringify(params.data);

        try {
          const data = await getProvinceCity(params);
          if (data.code == 1) {
            // this.columns = JSON.parse(data.data).list;
            // console.log(JSON.parse(data.data).list)
            let arr = JSON.parse(data.data).list;
            arr.splice(0, 1);

            this.columns = arr;
          }
        } catch (error) {
        }
      },

      onConfirm(value) {
        let valueArray = this.$refs.picker.getValues();

        this.formDate.cityName = value[0] + ',' + value[1];
        // this.cityCode = valueArray[1].code;
        console.log(valueArray);
        this.showPicker = false;
      },
      //提交
      async submit() {
        let params = {
          ...this.paramsData.params,
          data: { ...this.formDate },
        };
        console.log(this.paramsData);
        params.data = JSON.stringify(params.data);
        let data = await savePubliclyRecord(params);
        if (data.code == 1) {
          this.$toast('保存成功');
        } else {
          this.$toast(data.msg);
        }
      },
      //获取sence的参数 分享 带参数过多
      async getSceneId() {
        let params = {
          ...this.paramsData.params,
        };
        var href = window.location.href.split('?')[0];

        let paramsData = {
          url: href,
          shareTitle: this.shareTitle
            ? this.shareTitle
            :  this.shareAppObj.shareFriend[0].title,
          shareImg: this.shareImg
            ? this.shareImg
            :  this.shareAppObj.shareFriend[0].imgUrl,
        };
        let paramstring = JSON.stringify(paramsData);
        params.data = {
          shareParam: paramstring,
        };
        params.data = JSON.stringify(params.data);
        let data = await saveShareParam(params);
        if (data.code == 1) {
          let sceneId = JSON.parse(data.data).data;
          let urlparams = 'sceneId=' + sceneId;
          urlparams = encodeURIComponent(urlparams);
          let url = 'active/pages/commonWeb/commonWeb?scene=' + urlparams;
          // this.sharePlatformList[0].path = url;

            this.shareAppObj.shareFriend[0].path = url;
          if (this.paramsData.params.platform == 3) {
            // 点击跳转小程序页面
            wx.miniProgram.postMessage({
              data: {
                sceneIdShare: sceneId,
              },
            });
          }
        }
      },
      popShare() {
        this.showShare = !this.showShare;
        // this.$refs.child.jumpPage();
      },
      getShare(showShare) {
        this.showShare = false;
      },
      abs() {
        this.show = false;
      },
      linkGo() {
        if (this.paramsData.params.platform == 3) {
          this.show = true;
        } else {
          if (mobileType.isIOS()) {
            window.location.href = 'https://apps.apple.com/cn/app/id1526105345';
          } else if (mobileType.isAndroid()) {
            // window.location.href =
            //   "market://details?id=com.wsecar.designateddriver";
            window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.wsecar.designateddriver&scenevia=WXFUWUHAO-CAIDAN-1&g_f=1115331';
          }
        }
      },
    },
  };
</script>
<style scoped lang="less">
  .display {
    display: none;
  }

  .main {
    width: 100%;
    height: 100%;

    .commute-box2 {
      position: relative;
      height: calc(100vh);

      .van-swipe-item {
        position: relative;
      }

      .share {
        width: 100px;
        height: 50px;
        text-align: center;
        font-size: 20px;
        background: chocolate;
      }

      .boxSubmit {
        .boxInput {
          margin-bottom: 15px;

          input {
            border-bottom: 1px solid;
          }
        }
      }
    }

    .box {
      height: 100vh;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: cover;
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;

      img {
        width: 100%;
        position: absolute;
      }

      .icon {
        width: 29px;
        height: 23px;
        bottom: 4%;
        left: 50%;
        transform: translate(-50%, 0);
        animation: mymove 1s infinite;
        -webkit-animation: mymove 1s infinite;
      }

      @keyframes mymove {
        from {
          bottom: 4%;
        }
        to {
          bottom: 6%;
        }
      }

      @-webkit-keyframes mymove /*Safari and Chrome*/ {
        from {
          bottom: 4%;
        }
        to {
          bottom: 6%;
        }
      }

      .renpage2 {
        width: 128px;
        height: 171px;
        left: 0;
        bottom: 0;
      }
    }

    .page1 {
      .page1bj {
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
      }

      .logo {
        width: 98px;
        left: 15px;
        top: 15px;
      }

      .pagemain {
        width: 100%;
        height: 80%;
        top: 50%;
        left: 0;
        transform: translate(0, -50%);
      }
    }

    .page2 {
      .page2tittle {
        width: 293px;
        height: 144px;
        left: 50%;
        top: 2%;
        transform: translate(-50%, 0);
      }

      .page2main {
        width: 90%;
        height: 68%;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }

    .page3 {
      .pagemain3 {
        width: 90%;
        height: 80%;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }

    .page4 {
      .pagemain4 {
        width: 90%;
        height: 80%;
        left: 50%;
        top: 5%;
        transform: translate(-50%, 0);
      }
    }

    .page6 {
      width: 100%;
      height: 100vh;
      padding-top: 11%;
      position: static;

      .page6bj {
        // position: absolute;

        // left: 50%;
        // top: 7%;
        // transform: translate(-50%, 0);
        // background-size: cover;
        width: 90%;
        height: 100%;
        margin: 0 auto;
        position: static;
        display: block;
        background-size: 100% auto;
        background-repeat: no-repeat;

        .submint {
          width: 76%;
          position: static;
          margin: 5% auto;
          padding-top: 5%;
          display: block;
        }

        .down {
          width: 76%;
          margin: 0 auto;
          display: block;
          position: static;
        }

        .boxSubmit {
          // position: absolute;
          // left: 50%;
          // top: 18%;
          // transform: translate(-50%, 0);
          width: 80%;
          padding: 35% 5% 0;
          margin: 0 auto;

          .boxInput {
            margin-bottom: 15px;
            display: flex;
            align-items: center;

            .itemBox {
              display: flex;
            }

            .item {
              display: flex;
              align-items: center;
              text-align: center;
              margin-left: 40px;
            }

            img {
              position: inherit;
              width: 40px;
              vertical-align: top;
              margin-right: 10px;
            }

            label {
              font-size: 13px;
              width: 20%;
              display: block;

              span {
                color: #dc3b38;
                margin-left: 2px;
              }
            }

            input {
              display: block;
              width: 65%;
              height: 33px;
              margin-top: 2px;
              background: #f0f0f0;
              border-radius: 4px;
              border: 1px solid #dcdcdc;
              // text-indent:10px;
              padding: 0 5%;
            }
          }

          .city {
            display: block;
            width: 65%;
            height: 33px;
            line-height: 33px;
            margin-top: 2px;
            background: #f0f0f0;
            border-radius: 4px;
            border: 1px solid #dcdcdc;
            // text-indent:10px;
            padding: 0 5%;
            position: relative;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            img {
              width: 10px;
              position: absolute;
              right: 0;
              top: 50%;
              transform: translate(0, -50%);
            }
          }
        }
      }

      .sharebtn {
        width: 62px;
        height: 35px;
        right: 3%;
        top: 1%;
      }
    }
  }

  .wrapper {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 80%;
  }

  .block {
    img {
      width: 100%;
    }
  }
</style>
